export function isParentItemType(type) {
    return ({ parentItem }) => parentItem?.data?.type === type
}
